// extracted by mini-css-extract-plugin
export var icon = "_qd-0";